'use client';

import FaqCardAccordion from '@/components/FaqCard/FaqCard.Accordion';
import FaqCardAccordionItem from '@/components/FaqCard/FaqCard.AccordionItem';
import Box from '@/components/ui/Box';
import { FAQ_CARD_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { withFragmentArray } from '@liquorice/gql-utils';

const EventLayoutFaq = withFragmentArray(FAQ_CARD_FRAGMENT, (data) => {
  return (
    <Box cx={{ mY: '3xl' }}>
      <FaqCardAccordion>
        {data.map((item, index) => {
          return <FaqCardAccordionItem key={index} index={index} data={item} />;
        })}
      </FaqCardAccordion>
    </Box>
  );
});

export default EventLayoutFaq;
